import React from 'react';
import {
    default as OriginalAccordion,
    type AccordionTypeMap,
    type AccordionProps as OriginalAccordionProps,
} from '@mui/material/Accordion';
import { styled, useThemeProps } from '@mui/material/styles';
import clsx from 'clsx';
import { generateUtilityClasses } from '@mui/material';

export * from '@mui/material/Accordion';

export interface CaroteneAccordionClasses {
    root: string;
}

export type CaroteneAccordionClassKey = keyof CaroteneAccordionClasses;

export type AccordionProps<RootComponent extends React.ElementType = AccordionTypeMap['defaultComponent']> =
    OriginalAccordionProps<RootComponent, { size?: 'medium' | 'large' }>;

const accordionClassName = 'CaroteneAccordion';
export const caroteneAccordionClasses = generateUtilityClasses(accordionClassName, ['root']);

const AccordionThemed = styled(OriginalAccordion, {
    name: accordionClassName,
    slot: 'Root',
    overridesResolver: (props, styles) => styles.root,
})(() => ({}));

export const Accordion = React.forwardRef<HTMLDivElement, AccordionProps>(function (inProps, ref) {
    const props = useThemeProps({ props: inProps, name: accordionClassName });
    return <AccordionThemed ref={ref} {...props} className={clsx(props.className, caroteneAccordionClasses.root)} />;
});

Accordion.displayName = 'Accordion';
